import Immutable from 'immutable';
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import HoldingsProbe from '@bibliocommons/probes';
import AvailabilityDetailActions from '../actions/AvailabilityDetailActions';

const mapStateToProps = (state, ownProps) => ({
  probes: state.getIn(['entities', 'bibs', ownProps.id, 'probes'], Immutable.List())
});

const mapDispatchToProps = dispatch => (
  { ...bindActionCreators(AvailabilityDetailActions, dispatch) }
);

class HoldingsProbeContainer extends BcReactComponent {
  componentDidMount() {
    this.props.getHoldingsProbes(this.props.id);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.id && this.props.id !== nextProps.id) {
      this.props.getHoldingsProbes(nextProps.id);
    }
  }

  render () {
    const { probes } = this.props;
    return (
      <div className="cp-holdings-probes-list">
        {/* toObject is called on the probe to remain compatible with React in Rails */}
        { probes.map((probe) => <HoldingsProbe {...probe.toObject()} key={probe.metadataId} />) }
      </div>
    );
  }
}

HoldingsProbeContainer.propTypes = {
  probes: ImmutablePropTypes.list,
  getHoldingsProbes: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(HoldingsProbeContainer);



// WEBPACK FOOTER //
// ./app/containers/HoldingsProbeContainer.jsx